<template>
  <section class="moon-phase" :class="cssType">
    <img :src="cssType === 'mobile' ? moonPhaseTitleMobile : moonPhaseTitle" alt="moonPhaseTitle" class="title-img">
    <div class="introduction">
      {{ $t('midAutumn.moonPhase.introduction') }}
    </div>
    <div class="current-moon">
      <img :src="phases[currentIndex].img" :alt="phases[currentIndex].label" class="moon-img">
      <div class="moon-name">{{ phases[currentIndex].label }}</div>
    </div>
    <div class="progress">
      <div class="moons">
        <div class="moon" v-for="phase in phases" :key="phase.code">
          <img :src="phase.img" :alt="$t(`midAutumn.moonPhase.${phase.code}`)" class="moon-img">
          <div class="moon-name">{{ $t(`midAutumn.moonPhase.${phase.code}`) }}</div>
        </div>
        <div class="moon-line">
          <div class="moon-line-progress" :style="{ width: progress }"></div>
        </div>
      </div>
      <div class="reward" @click="rewardDialogVisible = true">
        <img src="@/views/act/midAutumnAccum2026/assets/imgs/baoxiang.png" alt="reward" class="reward-img">
      </div>
    </div>
    <Popup v-model="rewardDialogVisible" type="common">
      <div class="reward-dialog" :class="cssType">
        <div class="reward-dialog-text">{{ $t('midAutumn.moonPhase.introduction') }}</div>
        <img :src="chenghoubaoImg" :alt="$t('props.90501249')" class="reward-dialog-prop-img">
        <div class="reward-dialog-prop-name">{{ $t('props.90501249') }}</div>
      </div>
    </Popup>
  </section>
</template>

<script setup>
import { computed, defineProps, defineEmits, ref, watch } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import Popup from '../Popup/index.vue'
import ImgNewMoon from '@/views/act/midAutumnAccum2026/assets/imgs/moons/1.png'
import ImgCrescentMoon from '@/views/act/midAutumnAccum2026/assets/imgs/moons/2.png'
import ImgFirstQuarter from '@/views/act/midAutumnAccum2026/assets/imgs/moons/3.png'
import ImgGibbousMoon from '@/views/act/midAutumnAccum2026/assets/imgs/moons/4.png'
import ImgFullMoon from '@/views/act/midAutumnAccum2026/assets/imgs/moons/5.png'
import moonPhaseTitle from '@/views/act/midAutumnAccum2026/assets/imgs/moonPhaseTitle/index.js'
import moonPhaseTitleMobile from '@/views/act/midAutumnAccum2026/assets/imgs/mobile/moonPhaseTitle/index.js'
import chenghoubaoImg from '@/views/act/midAutumnAccum2026/assets/imgs/chenghao/index.js'

const rewardDialogVisible = ref(false)
const emit = defineEmits(['dialogOpen'])

watch(rewardDialogVisible, (visible) => {
  emit('dialogOpen', visible)
})

const props = defineProps({
  phaseIndex: {
    type: Number,
    default: 0,
  },
  phaseCode: {
    type: String,
    default: 'new_moon',
  },
  phaseName: {
    type: String,
    default: '',
  },
  isFullMoon: {
    type: Boolean,
    default: false,
  },
  progressPercent: {
    type: Number,
    default: 0,
  },
})

const { t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const definitions = [
  { code: 'new_moon', zh: '新月', img: ImgNewMoon, label: t('midAutumn.moonPhase.new_moon') },
  { code: 'crescent_moon', zh: '峨眉月', img: ImgCrescentMoon, label: t('midAutumn.moonPhase.crescent_moon') },
  { code: 'first_quarter', zh: '上弦月', img: ImgFirstQuarter, label: t('midAutumn.moonPhase.first_quarter') },
  { code: 'gibbous_moon', zh: '盈凸月', img: ImgGibbousMoon, label: t('midAutumn.moonPhase.gibbous_moon') },
  { code: 'full_moon', zh: '满月', img: ImgFullMoon, label: t('midAutumn.moonPhase.full_moon') },
]

const currentIndex = computed(() => Math.min(Math.max(Number(props.phaseIndex) || 0, 0), definitions.length - 1))
const phases = computed(() => {
  return definitions.map((item) => ({ ...item }))
})

const progress = computed(() => {
  const value = Number(props.progressPercent)
  const percent = Number.isFinite(value) && value > 0 ? value : currentIndex.value * 25
  return `${Math.min(Math.max(percent, 0), 100)}%`
})

</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
<!-- <style lang="less" scoped>
.moon-phase {
  position: relative;
  box-sizing: border-box;
  margin: 24px auto 0;
  // width: min(1180px, calc(100% - 40px));
  // min-height: 278px;
  padding: 28px 44px 24px;
  border-radius: 22px;
  background: linear-gradient(135deg, rgba(21, 39, 103, .96), rgba(52, 46, 117, .96));
  box-shadow: 0 14px 32px rgba(8, 15, 64, .24);
  color: #fff;
  // z-index: 3;
  font-family: Microsoft YaHei, sans-serif;
  .moon-phase-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    font-size: 24px;
    font-weight: bold;
    .moon-phase-current {
      color: #FFE681;
      font-size: 22px;
    }
  }
  .moon-phase-track {
    position: relative;
    height: 144px;
    margin-top: 20px;
  }
  .moon-phase-line {
    position: absolute;
    left: 0;
    right: 0;
    top: 32px;
    height: 8px;
    border-radius: 4px;
    background: rgba(255, 255, 255, .28);
    overflow: hidden;
    .moon-phase-line-progress {
      height: 100%;
      border-radius: inherit;
      background: linear-gradient(90deg, #F6C55C, #FFF4A1);
      transition: width .4s ease;
    }
  }
  .moon-phase-item {
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    width: 150px;
    text-align: center;
    opacity: .62;
    transition: opacity .3s ease, transform .3s ease;
    &.active { opacity: 1; }
    &.current { transform: translateX(-50%) scale(1.08); }
    .moon-phase-name {
      margin-top: 10px;
      white-space: nowrap;
      font-size: 17px;
    }
  }
  .moon {
    position: relative;
    width: 64px;
    height: 64px;
    margin: 0 auto;
    border-radius: 50%;
    background: #FBE78C;
    box-shadow: 0 0 14px rgba(255, 231, 137, .72);
    overflow: hidden;
    &::after {
      content: '';
      position: absolute;
      top: -2px;
      right: -2px;
      width: 66px;
      height: 66px;
      border-radius: 50%;
      background: #24336F;
      transform: translateX(0);
    }
    &.new_moon { background: #303D75; box-shadow: inset 0 0 0 2px rgba(255,255,255,.18); }
    &.new_moon::after { display: none; }
    &.crescent_moon::after { transform: translateX(28px); }
    &.first_quarter::after { transform: translateX(32px); }
    &.gibbous_moon::after { transform: translateX(48px); }
    &.full_moon::after { display: none; }
  }
  .moon-phase-tip {
    text-align: center;
    color: rgba(255, 255, 255, .82);
    font-size: 16px;
  }
}

.mobile.moon-phase {
  width: calc(100% - 28px);
  min-height: 242px;
  margin-top: 18px;
  padding: 22px 18px 18px;
  border-radius: 18px;
  .moon-phase-heading {
    font-size: 18px;
    .moon-phase-current { font-size: 16px; }
  }
  .moon-phase-track { height: 122px; margin-top: 16px; }
  .moon-phase-line { top: 27px; height: 6px; }
  .moon-phase-item {
    width: 74px;
    .moon { width: 42px; height: 42px; }
    .moon::after { width: 44px; height: 44px; }
    .moon.crescent_moon::after { transform: translateX(18px); }
    .moon.first_quarter::after { transform: translateX(21px); }
    .moon.gibbous_moon::after { transform: translateX(31px); }
    .moon-phase-name { margin-top: 8px; font-size: 11px; white-space: normal; line-height: 1.25; }
  }
  .moon-phase-tip { font-size: 12px; line-height: 1.4; }
}
</style> -->
